import React from 'react';
import * as S from './TripAdvisorGuestSays.styles';

const TripAdvisorGuestSays = ({ratings}) => {
  return (
    <S.GuestSaysWrapDiv>
      <S.GuestSaysOuterWrapDiv>
        <S.GuestSaysHeaderDiv>
          <S.HeadertxtDiv>What our guests say?</S.HeadertxtDiv>
        </S.GuestSaysHeaderDiv>
        <S.MainContentWrapperDiv>
          <S.MainContentOptionsDiv>
            {ratings.map(data => (
              <S.MainContentOptionsInnerDiv>
                <S.OptionsTxtDiv>{data.name}</S.OptionsTxtDiv>
                <S.RatingImgDiv src={data.imgUrl} alt="Segment Image" />
              </S.MainContentOptionsInnerDiv>
            ))}
          </S.MainContentOptionsDiv>
        </S.MainContentWrapperDiv>
      </S.GuestSaysOuterWrapDiv>
    </S.GuestSaysWrapDiv>
  );
};

export default TripAdvisorGuestSays;
